export function textareaHeight() {

  // Меняет высоту textarea, вместо скролла
  var elements = document.getElementsByTagName('textarea');
  for(var i = 0; i < elements.length; i++){
    elements[i].addEventListener('keyup', function(e){
      var target = e.target;
      
      target.style.height = '';

      if(target.scrollHeight > 120){
        target.style.height = target.scrollHeight + 'px';
      }
    });
  };
}